import { render, staticRenderFns } from "./bk-bets.vue?vue&type=template&id=1abb136e&scoped=true"
import script from "./bk-bets.vue?vue&type=script&lang=js"
export * from "./bk-bets.vue?vue&type=script&lang=js"
import style0 from "./bk-bets.vue?vue&type=style&index=0&id=1abb136e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abb136e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/bets/bk-bets.vue
// module id = rRf5
// module chunks = 0